module.exports = {
  internalCosts: 'transfeera.internal:debtor:costs:BRL:costs',
  tev: 'transfeera.internal:creditor:tev:BRL:1-10',
  validationCosts: 'transfeera.costs:debtor:validation:BRL:1-10',
  loadTest: 'transfeera.load.test:debtor:balance:BRL:1-20'
};
